<template>
  <baidu-map
    ref="bmap"
    class="map"
    :center="centerPath"
    :zoom="10"
    :scroll-wheel-zoom="true"
    v-if="centerPath"
  >
    <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
    <bm-polyline
      v-if="type == 'BOAT_TYPE'"
      :path="polylinePath"
      strokeColor="blue"
      :stroke-opacity="0.5"
      :stroke-weight="3"
    ></bm-polyline>
    <bm-driving
      v-if="type !== 'BOAT_TYPE' && polylinePath.length > 1"
      :start="startPath"
      :end="endPath"
      :waypoints="wayPath"
      :stroke-opacity="0.5"
      :stroke-weight="2"
      :panel="false"
      :auto-viewport="true"
    ></bm-driving>
    <!-- <bm-marker v-if="polylinePath.length == 1" :position="polylinePath[0]" :dragging="true"></bm-marker> -->
    <bm-marker
      v-if="positionStatus == 'Positioning' && type !== 'BOAT_TYPE'"
      :position="indexPath"
      :icon="{
        url: require('../../assets/images/car.png'),
        size: { width: 60, height: 80 },
      }"
    >
    </bm-marker>
  </baidu-map>
</template>

<script>
export default {
  data() {
    return {
      centerPath: {},
      polylinePath: [], //点 途径点
      startPath: "",
      endPath: "",
      wayPath: [], // 线 途径点
      position_status: this.positionStatus,
      type: this.mapType,
      indexPath: [],
    };
  },
  props: ["linePath", "mapType", "positionStatus"],
  created() {
    this.polylinePath = [];
    this.wayPath = [];
    this.polylinePath = this.linePath;
    this.position_status = this.positionStatus;
    this.centerPath = this.polylinePath[0];
    this.startPath = this.polylinePath[0];
    this.endPath = this.polylinePath[this.polylinePath.length - 1];
    for (let i = 2; i < this.polylinePath.length; i++) {
      this.wayPath.push(this.polylinePath[i - 1]);
    }
  },
  watch: {
    mapType: function (newVal, oldVal) {
      this.type = newVal;
    },
    linePath: function (newVal, oldVal) {
      this.polylinePath = newVal;
      this.centerPath = this.polylinePath[0];
      this.indexPath = this.polylinePath[this.polylinePath.length - 1];
      if (this.polylinePath.length > 1) {
        this.startPath = this.polylinePath[0];
        this.endPath = this.polylinePath[this.polylinePath.length - 1];
        for (let i = 2; i < this.polylinePath.length; i++) {
          this.wayPath.push(this.polylinePath[i - 1]);
        }
      }
    },
    positionStatus: function (newVal, oldVal) {
      this.position_status = newVal;
    },
  },
};
</script>
<style>
.map {
  width: 100%;
  height: 500px;
}
/* .anchorBL {
  display: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/map/map-line.vue